import React from 'react';
import { BoardsUebersicht } from '../../types';
import { waehlbareMitarbeiter } from '../../lib/board';

interface Props {
  uebersicht: BoardsUebersicht;
  /** Rolle des angezeigten Boards (board.rolle; bis es geladen ist die gewählte Rolle). */
  rolle: string | null;
  mitarbeiterId: number | null;
  onRolle: (rolle: string) => void;
  /** null = eigene Sicht (kein fremder Mitarbeiter). */
  onMitarbeiter: (mitarbeiterId: number | null) => void;
}

/** Rollenwahl des Dashboards: Chips der eigenen Rollen (nur die Boards, die zu den
 *  Benutzerrollen gehören - keine Simulation fremder Rollen). Admin/GF können das
 *  Board eines Mitarbeiters öffnen, der Projektleiter das seiner Mitarbeiter. */
const BoardRollenwahl: React.FC<Props> = ({ uebersicht, rolle, mitarbeiterId, onRolle, onMitarbeiter }) => {
  // null = keine Mitarbeiter-Auswahl; sonst nur Mitarbeiter mit Personen-Board
  const mitarbeiter = uebersicht.mitarbeiter === null ? null : waehlbareMitarbeiter(uebersicht);
  if (uebersicht.rollen.length === 0 && mitarbeiter === null) return null;

  return (
    <div className="k-board__wahl">
      {uebersicht.rollen.length > 0 && (
        <div className="k-board__wahl-gruppe" role="group" aria-label="Meine Rollen">
          {uebersicht.rollen.map(r => (
            <button
              key={r}
              type="button"
              className={'k-chip k-board__chip' + (r === rolle && mitarbeiterId === null ? ' is-active' : '')}
              aria-pressed={r === rolle && mitarbeiterId === null}
              onClick={() => onRolle(r)}
            >
              {r}
            </button>
          ))}
        </div>
      )}
      {mitarbeiter !== null && (
        <label className="k-board__wahl-gruppe k-board__mitarbeiter">
          <span className="k-board__wahl-label">Mitarbeiter</span>
          <select
            className="k-board__select"
            value={mitarbeiterId ?? ''}
            onChange={e => onMitarbeiter(e.target.value === '' ? null : Number(e.target.value))}
            disabled={mitarbeiter.length === 0}
          >
            <option value="">{mitarbeiter.length === 0 ? 'Keine Mitarbeiter' : 'Eigene Sicht'}</option>
            {mitarbeiter.map(m => (
              <option key={m.mitarbeiter_id} value={m.mitarbeiter_id}>
                {m.name} ({m.rolle})
              </option>
            ))}
          </select>
        </label>
      )}
    </div>
  );
};

export default BoardRollenwahl;
